// The Bolagsform <Select> on step one is driven by KYC question 103, whose
// options are a fixed set of labels. The corporate registry, however, returns
// a raw Swedish bolagsformkod (e.g. "BAB") that never matches those labels.
// This table translates each known code to the matching KYC q103 label so the
// field can be pre-filled. Codes not present here fall back to an empty,
// editable field — never a wrong value.
export const ORGANIZATION_TYPE_CODE_TO_KYC_LABEL: Record<string, string> = {
    // AB (aktiebolag and variants)
    AB: 'AB',
    LIMITED_COMPANY: 'AB',
    BAB: 'AB',
    PUBAB: 'AB',
    FAB: 'AB',
    MBAB: 'AB',
    BFAB: 'AB',
    EUR: 'AB',
    // Enskild firma (enskild näringsidkare)
    E: 'Enskild firma',
    EF: 'Enskild firma',
    ENSF: 'Enskild firma',
    // KB/HB (handelsbolag / kommanditbolag)
    HB: 'KB/HB',
    KB: 'KB/HB',
    // Kommun/landsting (kommun / region / landsting)
    KOM: 'Kommun/landsting',
    LAND: 'Kommun/landsting',
    REG: 'Kommun/landsting',
    KF: 'Kommun/landsting',
    // Förening (no longer blocked, see intro.tsx)
    BF: 'Förening',
    BRF: 'Förening',
    EK: 'Förening',
    FOF: 'Förening',
    I: 'Förening',
    KHF: 'Förening',
    SCE: 'Förening',
    TPF: 'Förening',
    TSF: 'Förening',
    SF: 'Förening',
    // Resurs's registry sends English names, e.g. for a BRF
    HOUSING_COMPANY: 'Förening',
    // Stiftelse
    STI: 'Stiftelse',
    STIF: 'Stiftelse',
};

/**
 * Translate a corporate-registry organizationTypeCode (e.g. "BAB") into the
 * matching KYC question-103 Bolagsform label (e.g. "AB"). Lookup is
 * case-insensitive. Returns '' for unknown codes so the Bolagsform field is
 * left empty and enabled rather than pre-filled with a value the <Select>
 * can't render.
 */
export const mapOrganizationTypeCodeToKycLabel = (code: string | null | undefined): string => {
    if (!code) {
        return '';
    }

    return ORGANIZATION_TYPE_CODE_TO_KYC_LABEL[code.trim().toUpperCase()] ?? '';
};
